import * as slugifyVendor from 'slugify';
import { CDN_URL, DEFAULT_SLIDE_KEY } from '../constants';

export const scroll = (id = '') => {
  if (!id) {
    return;
  }

  const el = document.getElementById(id);

  if (!el) {
    return;
  }

  el.scrollIntoView({ behavior: 'auto' });
};

export const stripHTML = (str = '') => {
  const text = new DOMParser().parseFromString(str, 'text/html');
  return text.documentElement.textContent;
};

export const slugify = (slug = '') => {
  return slugifyVendor(stripHTML(slug), {
    lower: true,
    remove: /[:,']/g,
  });
};

export const isURL = (str = '') => {
  try {
    return Boolean(new URL(str));
  } catch (e) {
    return false;
  }
};

export const getImageURL = (str = '') => {
  if (isURL(str)) {
    return str;
  }

  return `${CDN_URL}${str}`;
};

export const handleScrollToSlide = (id = null, index = null, section = null) => {
  if (index !== null) {
    const items = [id, index, section].filter((e) => e !== null);
    sessionStorage.setItem(DEFAULT_SLIDE_KEY, items.join('|'));
    window.dispatchEvent(new Event('storage'));
  }
};
